import { render, staticRenderFns } from "./ChipTableCommonPagination.vue?vue&type=template&id=b1310816"
import script from "./ChipTableCommonPagination.vue?vue&type=script&lang=js"
export * from "./ChipTableCommonPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports